<template>
  <div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #detailAddress="slotData">
        <p>{{slotData.data.row.wlUserAddress + slotData.data.row.wlUserAddressDetail}}</p>
      </template>
      <template #status="slotData">
        <p v-if="slotData.data.row.status == 0">新订单</p>
        <p v-if="slotData.data.row.status == 1">进行中</p>
        <p v-if="slotData.data.row.status == 2">已完成</p>
        <p v-if="slotData.data.row.status == 3">已取消</p>
      </template>
      <template #orderType="slotData">
        <p v-if="slotData.data.row.orderType == 1">可回收物</p>
        <p v-if="slotData.data.row.orderType == 2">家电回收</p>
      </template>
      <template #orderPic="slotData">
        <template v-if="slotData.data.row.orderPic && slotData.data.row.orderPic.length">
          <el-image
            v-for="(item, index) in slotData.data.row.orderPic.slice(0, 3)"
            :key="index"
            :src="item"
            :preview-src-list="slotData.data.row.orderPic"
            style="width: 60px; height: 60px; margin-right: 5px"
          >
            <div slot="placeholder" class="image-slot">
              加载中
              <span class="dot">...</span>
            </div>
          </el-image>
          <span
            v-if="slotData.data.row.orderPic.length > 3"
          >...共{{ slotData.data.row.orderPic.length }}张</span>
        </template>

        <span v-else>未上传</span>
      </template>
    </e-table>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  name: "deviceList",
  components: { eTable },
  mixins: [listMixin],
  mounted() {},
  computed: {},
  watch: {},
  data() {
    return {
      url: {
        list: "/frontUser/userRecycleOrderList",
      },
      queryParam: {},
      columns: [
        { field: "orderNo", label: "订单编号", width: 160 },
        {
          field: "status",
          label: "状态",
          slotName: "status",
          columnType: "slot",
        },
        { field: "userName", label: "签收用户" },
        { field: "phone", label: "联系方式" },
        {
          field: "detailAddress",
          label: "用户地址",
          slotName: "detailAddress",
          columnType: "slot",
        },
        { field: "actualWeight", label: "签收重量" },
        { field: "totalPrice", label: "签收金额" },

        {
          field: "orderType",
          label: "订单类型",
          slotName: "orderType",
          columnType: "slot",
        },
        { field: "wlRecycleUserNmae", label: "签收回收员" },

        { field: "appointmentTimeBegin", label: "预约时间" },

        { field: "signInTime", label: "签收时间" },
        { field: "recycleUserRemark", label: "回收员备注" },

        {
          width: 300,
          label: "照片",
          slotName: "orderPic",
          columnType: "slot",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style scoped lang="less"></style>
